import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { Button, Heading } from '../../components/ui'

type Props = {
  title: string
  onClose: () => void
  children: React.ReactNode
  footer?: React.ReactNode
  maxWidthClass?: string
  busy?: boolean
  onSubmit?: (e: React.FormEvent) => void
}

const EstoqueModal: React.FC<Props> = ({
  title,
  onClose,
  children,
  footer,
  maxWidthClass = 'max-w-lg',
  busy = false,
  onSubmit,
}) => {
  const body = (
    <>
      <div className="flex-1 space-y-4 overflow-y-auto px-5 py-4">{children}</div>
      {footer && (
        <div className="flex items-center justify-end gap-2 border-t border-gray-200 px-5 py-4 dark:border-gray-700">
          {footer}
        </div>
      )}
    </>
  )

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={busy ? undefined : onClose} />
      <div
        className={`relative z-10 flex max-h-[90vh] w-full ${maxWidthClass} flex-col overflow-hidden rounded-xl bg-white shadow-xl dark:bg-gray-800`}
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4 dark:border-gray-700">
          <Heading as="h3" size="xl" className="text-gray-900 dark:text-white">
            {title}
          </Heading>
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="rounded p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600 disabled:opacity-50 dark:hover:bg-gray-700"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        {onSubmit ? (
          <form onSubmit={onSubmit} className="flex min-h-0 flex-1 flex-col">
            {body}
          </form>
        ) : (
          body
        )}
      </div>
    </div>
  )
}

export function EstoqueModalActions({
  onCancel,
  saving,
  submitLabel = 'Salvar',
  submitDisabled = false,
  submitTitle,
}: {
  onCancel: () => void
  saving: boolean
  submitLabel?: string
  submitDisabled?: boolean
  submitTitle?: string
}) {
  const disabled = saving || submitDisabled
  return (
    <>
      <Button type="button" variant="outline" onClick={onCancel} disabled={saving}>
        Cancelar
      </Button>
      <Button type="submit" variant="solid" disabled={disabled} title={submitTitle}>
        {saving ? 'Salvando...' : submitLabel}
      </Button>
    </>
  )
}

export default EstoqueModal
